import React, { useCallback } from "react";
import { commonService } from "../../utils/commonService";

const CustomRangePicker = ({
  id,
  onChange,
  setOpenDatePicker,
  setActivePreset,
  activePreset,
}) => {
  const presets = [
    { label: "This Week", value: "thisWeek" },
    { label: "Next Week", value: "nextWeek" },
    { label: "This Month", value: "thisMonth" },
    { label: "Next Month", value: "nextMonth" },
  ];

  // 🔥 Normalize date to local start of day (timezone safe)
  const normalizeDate = (date) => {
    const d = new Date(date);
    d.setHours(0, 0, 0, 0);
    return d;
  };

  // 🔥 Get Monday (local timezone safe)
  const getMonday = (date) => {
    const d = normalizeDate(date);
    const day = d.getDay(); // 0 (Sun) - 6 (Sat)
    const diff = d.getDate() - (day === 0 ? 6 : day - 1);
    return normalizeDate(new Date(d.setDate(diff)));
  };

  const getPresetRange = useCallback((type) => {
    const today = normalizeDate(new Date());
    let start, end;

    switch (type) {
      case "thisWeek": {
        const monday = getMonday(today);
        start = monday;
        end = new Date(monday);
        end.setDate(monday.getDate() + 6);
        break;
      }

      case "nextWeek": {
        const monday = getMonday(today);
        start = new Date(monday);
        start.setDate(monday.getDate() + 7);
        end = new Date(monday);
        end.setDate(monday.getDate() + 13);
        break;
      }

      case "thisMonth":
        start = new Date(today.getFullYear(), today.getMonth(), 1);
        end = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        break;

      case "nextMonth":
        start = new Date(today.getFullYear(), today.getMonth() + 1, 1);
        end = new Date(today.getFullYear(), today.getMonth() + 2, 0);
        break;

      default:
        return null;
    }

    return {
      start: normalizeDate(start),
      end: normalizeDate(end),
    };
  }, []);

  const handlePresetClick = (type) => {
    const range = getPresetRange(type);
    if (!range) return;

    setActivePreset(type);

    if (onChange) {
      onChange(range.start, range.end, type);
    }

    setOpenDatePicker(false);
  };

  return (
    <div className="custom-range-picker me-2 mb-3">
      {presets.map((item) => (
        <button
          id={id ? `${id}-${item.value}` : undefined}
          key={item.value}
          type="button"
          className={`preset-btn text-center ${
            activePreset === item.value ? "active" : ""
          }`}
          onClick={(e) => {
            e.stopPropagation();
            handlePresetClick(item.value);
          }}
        >
          {item.label}
        </button>
      ))}
    </div>
  );
};

export default CustomRangePicker;